<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-dolly-flatbed" /> Compras
        </h2>
        <small class="text-muted">Controle as compras de sua empresa.</small>
      </div>

      <div class="col-md-6 text-right mt-3">
        <router-link v-if="purchaseCreateEdit" class="btn btn-success" to="/compras/novo">
          <i class="fas fa-plus" /> Nova Compra
        </router-link>
        <b-dropdown id="dropdown-1" text="Mais" class="m-md-2" right>
          <b-dropdown-item  @click="openPurchaseReport()"><i class="fas fa-print mr-2"></i>Imprimir Relatório</b-dropdown-item>  
        </b-dropdown>
      </div>
    </div>
    <br />

    <div class="row mt-2">
      <div class="col-md-12">
        <purchase-filter ref="PurchaseFilter" v-model="searchForm" @filter="select()"/>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-12">
        <purchase-list
          :purchases="purchases"
          @emitStockTransaction="handleEmitStockTransaction($event)"
          @emitPurchaseBill="handleEmitPurchaseBill($event)"
          @cancelPurchase="handleCancelPurchase($event)"
          @pagechange="select($event)"
        />
      </div>
    </div>

    <emit-purchase-stock-transaction-form
      ref="emitPurchaseStockTransactionForm"
      @store="select(searchForm.page)"
    />
    <emit-purchase-bill-form
      ref="emitPurchaseBillForm"
      @store="select(searchForm.page)"
    />
    
    <cancel-purchase-modal ref="cancelPurchaseModal" @store="select(searchForm.page)"/>
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters";
import moment from "moment";
import purchaseList from "@/components/purchase/lists/PurchaseList";
import emitPurchaseStockTransactionForm from "@/components/purchase/forms/EmitPurchaseStockTransactionForm";
import emitPurchaseBillForm from "@/components/purchase/forms/EmitPurchaseBillForm"
import cancelPurchaseModal from "@/components/purchase/sections/CancelPurchaseModal";
import PurchaseFilter from '../../components/purchase/sections/PurchaseFilter.vue';

export default {
  components: { purchaseList, emitPurchaseStockTransactionForm, emitPurchaseBillForm, cancelPurchaseModal, PurchaseFilter },

  data: function () {
    return {
      searchForm: {   
        status: ["d", "p","c"],
        finance_status: {},
        page: 1,
      },

      showFilters : false,
      //   error: null,
    };
  },

  computed: {
    purchaseCreateEdit () {
			return this.$acl.can('purchaseCreateEdit')
    },
    purchases() {
      return this.$store.state.purchase.purchases;
    },
  },

  async created() {
    await this.$store.dispatch("purchase/getPurchases", {
      status: ["d", "p", "c"],
    });

    this.$store.commit("pageHasLoaded");
  },

  methods: {
    async select(page = 1) {
      this.searchForm.page = page;

      this.$store.commit("showLoading");

      await this.$store
        .dispatch("purchase/getPurchases", this.searchForm)
        .then((response) => {})
        .catch((error) => {
          this.error = error;
        });

      this.$store.commit("hideLoading");
    },

    redirect(id) {
      this.$router.push({
        path: "/compras/editar/" + id,
      });
    },

    handleEmitStockTransaction(purchase) {
      this.$refs.emitPurchaseStockTransactionForm.open(purchase);
    },

    handleEmitPurchaseBill(purchase) {
      this.$refs.emitPurchaseBillForm.open(purchase)
    },

    handleCancelPurchase(purchase) {
      this.$refs.cancelPurchaseModal.open(purchase)
    },

    openPurchaseReport() {
      window.open("/compras/relatorio");
    },
  },
};
</script>
